import '../utils/link-more';

const devicePixelRatio= window.devicePixelRatio;

if(devicePixelRatio > 1){
    $('#mlist').remove();
    $('#mlist2x').show().linkMore({ num: 15 });
}else {
    $('#mlist2x').remove();
    $('#mlist').show().linkMore({ num: 15 });
}




// WEBPACK FOOTER //
// ./src/js/cooperators.js